import { EventEmitter } from "eventemitter3";
import { action, computed } from "mobx";
import { syncCanvasIdAtom } from "../SharedIframeState";
import { Action, ActionMeta, ActionType } from "../Types";
import { isPresenceAction } from "../Utils";
import { canvasReducer } from "./CanvasReducer";
import { canvasAtom } from "./CanvasState";
import { ParentComlinkAPI } from "./FrameSandboxAPI";
import { presenceState } from "./Presence";
import { doesLocalActionReplace } from "./SandboxUtils";
import { applicationState } from "./Sync";

export const CanvasDispatchEmitter = new EventEmitter();

function collapseLocalActions(
  localActions: [Action, ActionMeta][]
): [Action, ActionMeta][] {
  // filter out consecutive NoOp
  return localActions.filter(([action, meta], i) => {
    return !(
      action[0] === ActionType.NoOp &&
      localActions[i + 1]?.[0][0] === ActionType.NoOp
    );
  });
}

const canvasDispatchGet = computed(() => {
  if (computed(() => syncCanvasIdAtom.value !== undefined).get()) {
    return action((action: Action) => {
      if (isPresenceAction(action) && Object.keys(presenceState).length < 2) {
        // ignore presence actions if we're only one here
        return;
      }

      const { lastActionId, localActions } = applicationState;
      const actionId = (lastActionId ?? 0) + 1;
      const processedLocalActions: [Action, ActionMeta][] = localActions.map(
        (localAction) => {
          const [a, meta] = localAction;
          return doesLocalActionReplace(action, a)
            ? [[ActionType.NoOp], meta]
            : localAction;
        }
      );
      applicationState.lastActionId = actionId;
      applicationState.localActions = [
        ...collapseLocalActions(processedLocalActions),
        [action, [actionId]],
      ];
    });
  } else {
    return action((action: Action) => {
      const updatedCanvas = canvasReducer(canvasAtom.value, action);
      if (updatedCanvas === canvasAtom.value) {
        return;
      }
      canvasAtom.value = updatedCanvas;
      ParentComlinkAPI.sendCanvasUpdate(updatedCanvas);
      CanvasDispatchEmitter.emit(`${action[0]}`, action[1]);
    });
  }
});

export function canvasDispatch(action: Action) {
  canvasDispatchGet.get()(action);
}
